import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AnalysisState } from '../../stores/analysis-state/analysis-state.store';

import { Analyst } from '@analysis/domain';
import { SampleAiAnalysisStatus } from '@analysis/use-cases';
import { AiDisclaimerService } from '../../services/ai-disclaimer/ai-disclaimer.service';

@Component({
  selector: 'ts-ai-analysis-selection-panel',
  templateUrl: './ai-analysis-selection-panel.component.html',
  styleUrls: ['./ai-analysis-selection-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AiAnalysisSelectionPanelComponent implements OnChanges {
  @Input() public readonly editMode: boolean;
  @Input() public readonly aiAlgorithms: Analyst[];
  @Input() public readonly analysisStates: Map<string, AnalysisState>;
  @Input() public readonly analystSelected: Analyst;
  @Input() public readonly editingEnabled = false;
  @Input() public readonly aiAnalysisStatus?: SampleAiAnalysisStatus;

  @Output() analystChange = new EventEmitter<Analyst>();

  disclaimerAccepted = false;

  constructor(
    private readonly disclaimerService: AiDisclaimerService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['analystSelected'] || !this.analystSelected?.id) {
      return;
    }

    this.syncDisclaimerState(this.analystSelected);
  }

  getStateFor(id: string): AnalysisState | undefined {
    return this.analysisStates.get(id);
  }

  executionState(analysisState?: AnalysisState): string | undefined {
    if (this.aiAnalysisStatus === 'ready') return 'analyzed';
    if (this.aiAnalysisStatus === 'inProgress') return 'inProgress';
    if (this.aiAnalysisStatus === 'error') return 'error';
    return analysisState?.state;
  }

  public compareAnalysts = (a: Analyst | null, b: Analyst | null): boolean => a?.id === b?.id;

  private syncDisclaimerState(analyst: Analyst): void {
    this.disclaimerAccepted = this.disclaimerService.getDisclaimerAcceptedState(analyst);
    this.cdr.markForCheck();

    if (this.disclaimerAccepted) {
      return;
    }

    this.disclaimerService.ensureDisclaimerAccepted(analyst).subscribe((accepted) => {
      this.disclaimerAccepted = accepted;
      this.cdr.markForCheck();
    });
  }
}
